import { configureStore } from "@reduxjs/toolkit";
import rootReducer from "./userSlice/user"

export const store = configureStore({
  reducer: {
    user: rootReducer,
  },
});
